import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppGlobals } from "@app/app.global";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class DashboardService {
  constructor(private http: HttpClient, private appGlobals: AppGlobals) { }

  getInvoiceCount(): Observable<{ [key: string]: number }> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.invoice}invoice-count`);
  }

  getReviewedInvoiceCount(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<{ count: number, change: number }> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.dashboard}reviewed-invoice-count`, { params: filters });
  }

  dashboardOverview(filters: HttpParams | { [params: string]: string | string[] } = {}):
    Observable<{ statuses: { [key: string]: number }, documentTypes: { taxInvoice: number, creditNote: number }, statusWiseInvoiceCount: any, invoiceAmount: any, invoiceGst: any, timeWiseSummary: any }> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.dashboard}overview-tab-dashboard`, { params: filters });
  }

  getInvoiceAmount(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<{ amount: number, change: number }> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.dashboard}invoice-amount`, { params: filters });
  }

  getInvoiceItemAmount(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<{ amount: number, change: number }> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.dashboard}invoice-item-amount`, { params: filters });
  }

  getInvoieGst(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<{ gst: number, change: number }> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.dashboard}invoice-gst`, { params: filters });
  }

  getTimeWiseInvoice(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<{ [key: string]: { key: string, amount: number, gst: number, vat: number, cess: number, excise: number, count: number }[] }> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.dashboard}time-wise-invoice-summary`, { params: filters });
  }

  getSupplierCount(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<{ suppliers: number, change: number }> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.dashboard}supplier-count`, { params: filters });
  }

  getSupplierTabDashboard(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.dashboard}supplier-tab-dashboard`, { params: filters });
  }

  getSuppliers(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<{
    name: string;
    count: number;
    amount: number;
    gst: number;
  }[]> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.dashboard}supplier-list`, { params: filters });
  }

  getSupplierWiseInvoiceSummary(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<{
    supplier: string;
    count: number;
    amount: number;
    gst: number;
    vat: number;
    cess: number;
    excise: number;
  }[]> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.dashboard}supplier-wise-invoice-summary`, { params: filters });
  }

  getItemTabDashboard(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.dashboard}item-tab-dashboard`, { params: filters });
  }

  getProductCount(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<any> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.dashboard}product-count`, { params: filters });
  }

  getTotalExpenseCount(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<{ totalExpenseAmount: number, change: number }> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.dashboard}total-expense-count`, { params: filters });
  }

  getProductWiseSummary(filters: HttpParams | { [params: string]: string | string[] } = {}): Observable<{
    description: string;
    price: number;
    quantity: number;
    unit: string;
  }[]> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.dashboard}product-wise-invoice-summary`, { params: filters });
  }

  productList(searchTerm: string, filters: HttpParams | { [params: string]: string | string[] } = {}) {
    return this.http.get<any>(`${this.appGlobals.apiUrl.dashboard}product-list`, { params: { search: searchTerm, ...filters } });
  }

  topProductList(filters: HttpParams | { [params: string]: string | string[] } = {}) {
    return this.http.post<any>(`${this.appGlobals.apiUrl.dashboard}price-wise-top-n-products`, filters);
  }

  productPriceDetails(filter: any) {
    return this.http.post<any>(`${this.appGlobals.apiUrl.dashboard}product-price-detail`, filter);
  }

  productPriceTrend(filter: any) {
    return this.http.post<any>(`${this.appGlobals.apiUrl.dashboard}product-price-trend`, filter);
  }

  getSupplierInvoiceSummaryReport(filters: HttpParams | { [params: string]: string | string[] } = {}) {
    return this.http.get<any>(`${this.appGlobals.apiUrl.dashboard}supplier-invoice-summary-report`, { params: filters });
  }

  getSupplierItemWiseSummaryReport(filters: HttpParams | { [params: string]: string | string[] } = {}) {
    return this.http.get<any>(`${this.appGlobals.apiUrl.dashboard}supplier-item-report`, { params: filters });
  }
}